import React from 'react';

import './Condition.css'

import classnames from 'classnames'

const Condition = (props) => {
  const { condition, editId, blur } = props
  const { setId } = props
  const _condition = condition.condition
  const {id} = condition
  
  const highlightFlag = editId === id

  const conClassname = classnames('con', {
    'highlight': highlightFlag,
    'blur': blur && id !== editId,
  })
  return (
    <li className={conClassname} onClick={(e) => { highlightFlag ? setId(null) : setId(id)}}>
      {
        _condition === "" ? (
          <BlankCondition />
        ) : (
          _condition
        )
      }
    </li>
  )
}

const BlankCondition = (props) => (
  <span style={{color: 'grey'}}>빈 컨디션</span>
)

export default Condition